// src/components/HomeHero/HomeHero.tsx
import React from "react";
import heroIllustration from "../../assets/img/elenoit-illustrator.png"; // Path to your illustrative graphic
import waveShape from "../../assets/img/home-bottom-shape.png"; // Path to your bottom wave shape
// SectionIcon is imported but not used in the provided code, consider removing if not needed.
// import { SectionIcon } from "lucide-react";

interface HomeHeroProps {
  id: string;
}

const HomeHero: React.FC<HomeHeroProps> = ({ id }) => {
  const scrollToContact = () => {
    const element = document.getElementById("contactus"); // Make sure this matches your App.tsx ID
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="relative bg-gradient-to-b from-[#3c176e] to-[#0793d0] overflow-hidden pt-24 pb-0 min-h-[700px] flex flex-col justify-center">
      {/* Content Wrapper */}
      <div className="container mx-auto px-4 flex flex-col md:flex-row items-center gap-8 md:gap-0">
        {/* Left: Heading/Text/Button */}
        <div className="w-full md:w-1/2 flex flex-col items-start justify-center md:pl-6 z-10">
          <h1 className="text-white text-4xl md:text-6xl font-bold mb-6 mt-10 md:mt-0">
            Empowering Business
          </h1>
          <p className="text-white text-lg md:text-xl mb-8 leading-relaxed max-w-lg">
            Empowering Business from Simplified IT Solutions To Connected
            Marketing Strategies, Expediting The Growth And Evolution With
            Proven Strategies, Technology &amp; Innovation
          </p>
          <a
            href="/contact#contactForm"
            className="px-8 py-3 rounded-md bg-[#8d6dfb] hover:bg-[#6a34eb] text-white font-semibold transition shadow-lg"
          >
            Contact Us
          </a>
        </div>
        {/* Right: Illustration */}
        <div className="w-full md:w-1/2 flex justify-center md:justify-center relative z-10">
          <img
            src={heroIllustration}
            alt="Empowering Business"
            className="max-w-[420px] md:max-w-[580px] h-auto relative" // *No negative margin bottom*
            draggable="false"
            style={{ minWidth: "260px" }}
          />
        </div>
      </div>
      {/* Wave Shape (ABSOLUTE) */}
      <img
        src={waveShape}
        alt="Bottom Wave"
        className="absolute bottom-0 left-0 w-full pointer-events-none select-none z-0"
        draggable="false"
        style={{ marginBottom: "-2px" }} // Ensures NO blue line
      />
    </section>
  );
};

export default HomeHero;
